// Life cycle stage.
export var CHART_LIFE_CIRCLE;
(function (CHART_LIFE_CIRCLE) {
    CHART_LIFE_CIRCLE["BEFORE_RENDER"] = "beforerender";
    CHART_LIFE_CIRCLE["AFTER_RENDER"] = "afterrender";
    CHART_LIFE_CIRCLE["BEFORE_PAINT"] = "beforepaint";
    CHART_LIFE_CIRCLE["AFTER_PAINT"] = "afterpaint";
    CHART_LIFE_CIRCLE["BEFORE_CHANGE_DATA"] = "beforechangedata";
    CHART_LIFE_CIRCLE["AFTER_CHANGE_DATA"] = "afterchangedata";
    CHART_LIFE_CIRCLE["BEFORE_CLEAR"] = "beforeclear";
    CHART_LIFE_CIRCLE["AFTER_CLEAR"] = "afterclear";
    CHART_LIFE_CIRCLE["BEFORE_DESTROY"] = "beforedestroy";
    CHART_LIFE_CIRCLE["AFTER_DESTROY"] = "afterdestroy";
    CHART_LIFE_CIRCLE["BEFORE_CHANGE_SIZE"] = "beforechangesize";
    CHART_LIFE_CIRCLE["AFTER_CHANGE_SIZE"] = "afterchangesize";
})(CHART_LIFE_CIRCLE || (CHART_LIFE_CIRCLE = {}));
//# sourceMappingURL=event.js.map